<template>
    <div class="rightGraphics reveal" id="tldr">
        <img 
			class ="deviceTop rellax" 
			src="@/assets/images/device/tldr-phone-top.png" 
			alt="iphone-X-black" 
			data-rellax-speed="1.5" 
			data-rellax-percentage="0.5"/>

        <img 
			class ="deviceMiddle rellax" 
			src="@/assets/images/device/tldr-phone-middle.png" 
			alt="iphone-X-black" 
			data-rellax-speed="0.5" 
			data-rellax-percentage="0.5"/>
        <img 
			class ="deviceBottom rellax" 
			src="@/assets/images/device/tldr-phone-bottom.png" 
			alt="iphone-X-black" 
			data-rellax-speed="-0.5" 
			data-rellax-percentage="0.5"/>
    </div>
</template>

<script>

export default {
  name: 'TLDRRightColumn',
};




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }

.rightGraphics {
    display: flex;
    flex-direction: column;
}

.deviceTop {
    z-index: 3;
}

.deviceMiddle {
    margin-left: -5%;
    margin-top: -20%;
    z-index: 2;
}

.deviceBottom {
    margin-top: -38%;
    z-index: 1;
}

.deviceTop, .deviceMiddle, .deviceBottom {

	@include breakpoint1 {
		width: 100%;
		align-self: center;
	}

	@include breakpoint2 {
		width: 60%;
		align-self: center;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/TLDR/TLDRRight.vue